<template>
  <div class="purchase-success-container" @click="onDismiss">
    <div class="alert-container">
      <img src="@/assets/alertsuccess.png" class="logo" />
      <span class="title mt30">Your purchase was successfull</span>
      <span class="message">We sent a SMS with redeem code detail to</span>
      <div class="info-container mt25">
        <span v-if="infoName != ''" class="info-message">{{infoName}}</span>
        <span class="info-message">{{infoPhone}}</span>
      </div>
      <span class="bottom-button normal-button" @click="onDismiss">Continue Shopping</span>
      <span class="home-button normal-button" @click="onHomeClick">Home {{storeName}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "PurchaseSuccess",
  props: {
    infoName: {
      type: String,
      default: ""
    },
    infoPhone: {
      type: String,
      isRequired: true
    },
    storeName: {
      type: String,
      isRequired: true
    }
  },
  methods: {
    onDismiss() {
      this.$emit("onDismiss");
    },
    onHomeClick() {
      this.$emit("onHomeClick");
    }
  }
};
</script>
<style lang="scss" scoped>
.purchase-success-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: rgba($color: #000000, $alpha: 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .alert-container {
    display: flex;
    flex-direction: column;
    background-color: white;
    align-items: center;
    padding: 40px 15px 20px 15px;
    border-radius: 5px;
    margin: 0 10px;
    box-shadow: 0 10px 20px rgba($color: #000000, $alpha: 0.1);
    text-align: center;
    .logo {
      width: 80px;
      height: 80px;
    }
    .title {
      font-family: "SFProText-Semibold" -apple-system;
      font-weight: 600;
      font-size: 20px;
    }
    .message {
      font-family: "SFProText-Medium" -apple-system;
      font-weight: 500;
      font-size: 16px;
      padding: 0 35px;
      margin-top: 25px;
    }
    .info-container {
      display: flex;
      flex-direction: column;
    }
    .info-message {
      font-family: "SFProText-Bold" -apple-system;
      font-weight: bold;
      font-size: 16px;
      padding: 0 35px;
    }
    .bottom-button {
      font-family: "SFUIText-Medium" -apple-system;
      font-weight: 600;
      font-size: 16px;
      color: #2e2323;
      padding: 16px 0;
      margin-top: 50px;
      width: 100%;
      border: 1px solid #2e2323;
      border-radius: 5px;
    }
    .home-button {
      font-family: "SFUIText-Medium" -apple-system;
      font-weight: 600;
      font-size: 16px;
      color: white;
      padding: 16px 0;
      width: 100%;
      margin-top: 20px;
      background-color: #2e2323;
      border-radius: 5px;
    }
  }
}
</style>
